export default __webpack_public_path__ + "static/media/Insufficient.a20a7b2f.svg";